import { render, staticRenderFns } from "./booking-status.vue?vue&type=template&id=69223a61&scoped=true"
import script from "./booking-status.vue?vue&type=script&lang=ts"
export * from "./booking-status.vue?vue&type=script&lang=ts"
import style0 from "./booking-status.vue?vue&type=style&index=0&id=69223a61&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69223a61",
  null
  
)

export default component.exports